export default __webpack_public_path__ + "static/media/p.d1cd4e3f.svg";